import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {Link} from "@inertiajs/react";

export default function BackButton({ folderId }: { folderId?: string | null }) {
    const href = folderId
        ? route('dashboard.folder', folderId)
        : route('dashboard');

    return (
        <Link
            href={href}
            className="py-1.5 px-3 me-4 text-sm font-medium text-gray-900 dark:text-gray-100 focus:outline-none bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-blue-700 dark:hover:text-blue-400 inline-block"
        >
            <FontAwesomeIcon
                className={`align-middle w-4 h-4 items-center`}
                icon={faArrowLeft}
            />
        </Link>
    );
}
